import React from 'react';
import { Button, utils } from 'react-bootstrap';
import classNames from 'classnames';
import { omit } from 'underscore';

// I'm still testing this approach. Please don't use yet -- y
// refer to app/assets/stylesheets/academia_components/buttons.scss
utils.bootstrapUtils.addStyle(Button, 'candy');

export const StandardButton = (props) => {
  const buttonProps = {
    className: classNames(props.className, {
      emphasize: props.emphasize,
    }),
    // the props to pass thru to react bootstrap's Button
    ...omit(props, ['emphasize', 'children', 'className']),
  };

  return React.createElement(Button, buttonProps, props.children);
};

export default StandardButton;
